import { render } from "./designGroupTitle.vue?vue&type=template&id=5a0d7024&scoped=true"
import script from "./designGroupTitle.vue?vue&type=script&lang=js"
export * from "./designGroupTitle.vue?vue&type=script&lang=js"

import "./designGroupTitle.vue?vue&type=style&index=0&id=5a0d7024&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0d7024"]])

export default __exports__